import React from 'react';

interface NodeLabelProps {
  className: string;
  nodeData: {
    name: string;
  };
}

class NodeLabel extends React.PureComponent<NodeLabelProps> {
  render() {
    const { className, nodeData } = this.props;
    return (
      <div
        className={className}
        style={{
          background: 'whitesmoke',
          height: '100px',
          width:'182px',
          fontWeight:'700',
          alignItems:'center',
          overflow:'auto',
          borderTop: '5px solid #00387C',
          textAlign: 'center',
          zIndex: '1000',
          fontSize:'13px',
          boxShadow: '0px 10px 10px rgba(0, 0, 0, 0.4)',
          borderRadius: '20px',
          display:'flex',
          flexDirection:'row',
          justifyContent:'center'
        }}

      >
        {nodeData.name}
      </div>
    );
  }
}

export default NodeLabel;